import { PaddedWrapper } from "../../components/wrappers/paddedWrapper";
import { StaticContainer } from "../../components/wrappers/staticContainer";
import { AllstarBotContent } from "./content";
import { Flex, Box } from "rebass/styled-components";
import { Large3, Title2 } from "../../components/text";
import styled from "styled-components";

const HeroSection = styled(Flex)`
  align-items: center;
  flex-direction: column;
  padding-top: 80px;
  padding-bottom: 20px;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    padding-top: 60px;
  }
`;

const BotAvatar = styled.img`
  height: 96px;
  margin-bottom: 20px;
  width: 96px;
`;

const Subtitle = styled(Title2)`
  color: ${({ theme }) => theme.colors.chalk};
  max-width: 500px;
`;

export default function AllstarBotPage() {
  return (
    <>
      <HeroSection>
        <BotAvatar
          src="https://media.allstar.gg/static/web/allstarbot.png"
          alt="AllstarBot"
        />
        <Large3 mb={4} style={{ fontWeight: 600 }}>
          Get Started with AllstarBot
        </Large3>
        <Subtitle>
          Match notifications, clip sharing, and more — delivered straight to
          your Discord
        </Subtitle>
      </HeroSection>
      <StaticContainer py={8}>
        <PaddedWrapper
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <AllstarBotContent />
        </PaddedWrapper>
      </StaticContainer>
    </>
  );
}
